const BaseModalComponent = {
    transclude: true,
    templateUrl: '/ui/modal/baseModal/baseModal.tpl.html',
    controller: 'baseModalController',
    bindings: {
        modalTitle: '<?',
        ok: '<?',
        cancel: '<?',
        thirdButton: '<?',
        isConfirmDisabled: '<?',
        isThirdButtonDisabled: '<?',
        confirmButtonUrl: '<?',
        onConfirm: '&?',
        onCancel: '&?',
        onThirdButton: '&?',
        okButtonClass: '<?',
        thirdButtonClass: '<?'
    }
};

angular.module('umCore')
    .component('baseModal', BaseModalComponent);
